module.exports = __webpack_public_path__ + "src/assets/img/orekhovo-medvedkovskaya.f4b2d9ae.jpg";